
import React from 'react';
import styles from './AboutPage.module.css';
import md from '../assets/maheen.jpg';
import ceo from '../assets/hassan.jpg'
const AboutPage = () => {
  return (
    <div className={styles.aboutPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroBackground}>
          <div className={styles.backgroundPattern}></div>
        </div>
        <div className={styles.heroContainer}>
          <h1 className={styles.heroTitle}>About Us</h1>
        </div>
      </section>

      {/* Professional IT Solutions Section */}
      <section className={styles.solutionsSection}>
        <div className={styles.solutionsContainer}>
          <div className={styles.solutionsVisual}>
            <div className={styles.illustrationWrapper}>
              <div className={styles.isometricIllustration}>
                {/* Isometric elements */}
                <div className={styles.mainScreen}></div>
                <div className={styles.shieldIcon}></div>
                <div className={styles.lockIcon}></div>
                <div className={styles.personFigure}></div>
                <div className={styles.dataBlocks}></div>
                <div className={styles.securityElements}></div>
                <div className={styles.computerScreen}></div>
                <div className={styles.mobileDevice}></div>
                <div className={styles.cloudElements}></div>
              </div>
            </div>
          </div>
          
          <div className={styles.solutionsContent}>
            <h2 className={styles.solutionsTitle}>
              We Offer Professional IT<br />
              <span className={styles.redText}>Solutions</span> For Your<br />
              Business
            </h2>
            <p className={styles.solutionsDescription}>
              At Virtual IP, we specialize in guiding businesses through 
              industry transitions to ensure competitiveness. With a seasoned 
              team of experts, we prioritize your success and offer strategies 
              for thriving in the future.
            </p>
            <div className={styles.featuresList}>
              <div className={styles.featureItem}>
                <div className={styles.checkIcon}>✓</div>
                <span>Industry transformation guidance for businesses of all sizes</span>
              </div>
              <div className={styles.featureItem}>
                <div className={styles.checkIcon}>✓</div>
                <span>Experienced team dedicated to your success</span>
              </div>
              <div className={styles.featureItem}>
                <div className={styles.checkIcon}>✓</div>
                <span>Strategic insights for thriving in evolving landscapes</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Members Section */}
      <section className={styles.teamSection}>
        <div className={styles.teamContainer}>
          <div className={styles.teamHeader}>
            <div className={styles.sectionLabel}>Our Staff</div>
            <h2 className={styles.teamTitle}>Our Team Members</h2>
          </div>
          
          <div className={styles.teamGrid}>
            <div className={styles.teamCard}>
              <div className={styles.teamImageWrapper}>
                <img 
                  src={md}
                  alt="Maheen Malik"
                  className={styles.teamImage}
                />
              </div>
              <div className={styles.teamInfo}>
                <h3 className={styles.memberName}>MAHEEN MALIK</h3>
                <p className={styles.memberRole}>Managing Director</p>
              </div>
            </div>
            
            <div className={styles.teamCard}>
              <div className={styles.teamImageWrapper}>
                <img 
                  src={ceo}
                  alt="Syed Hasan"
                  className={styles.teamImage}
                />
              </div>
              <div className={styles.teamInfo}>
                <h3 className={styles.memberName}>SYED HASAN</h3>
                <p className={styles.memberRole}>CEO and Founder</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;